export function getFormatNumberByLocale(value: number, decimals: number = 2): string {
	const locale = navigator.language || 'en-US';

	const intl = new Intl.NumberFormat(locale, {
		minimumFractionDigits: 0,
		maximumFractionDigits: decimals
	});

	return intl.format(value);
}




